const cookieBtn = document.querySelector(".js-cookie-button");
const cookie = document.querySelector(".js-cookie");

if (cookie) {
    cookieBtn.addEventListener("click", () => {
        cookie.classList.add("hidden");
        localStorage.setItem("cookie", JSON.stringify("visited"));
    });

    const localStorageData = JSON.parse(localStorage.getItem("cookie"));

    if (localStorageData === "visited") {
        cookie.classList.add("hidden");
    }
}
